// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a4b2f084","777":"46c96da3","977":"e491956b"}[chunkId] + ".chunk.js";
};